<template>
  <div :class="starsCssClasses">
    <div class="c-stars__inner" @mouseleave="resetRating">
      <ul class="c-stars__list">
        <li v-for="n in 5" :key="n" class="c-stars__list__item">
          <span :class="icoCssClasses" @click="selectRating(n)" @mousemove="highlightStars(n)">
            <svg>
              <use xlink:href="#svg-icon-star-silver"></use>
            </svg>
          </span>
        </li>
      </ul>
      <div class="c-stars__progress">
        <ul class="c-stars__list">
          <li v-for="n in 5" :key="n" class="c-stars__list__item">
            <span :class="icoCssClasses" @click="selectRating(n)" @mousemove="highlightStars(n)">
              <svg>
                 <use xlink:href="#svg-icon-star-gold"></use>
              </svg>
            </span>
          </li>
        </ul>
      </div>
    </div>
    <slot name="bottom">
      <template v-if="ratingStatus">
        <p class="c-stars__status">{{ ratingStatus }}</p>
      </template>
      <template v-else>
        <p class="c-stars__status">&nbsp;</p>
      </template>
    </slot>
    <slot name="bottom" />
  </div>
</template>
<script>
const ratingStatuses = ['bardzo słaby', 'słaby', 'średni', 'dobry', 'bardzo dobry']

export default {
  props: {
    startRating: {
      type: Number,
      default: 5
    },
    size: {
      type: String,
      default: 'm'
    },
    inline: {
      type: Boolean,
      default: false
    },
    centered: {
      type: Boolean,
      default: false
    },
    readonly: {
      type: Boolean,
      default: false
    },
    preventVisuallyRatingChange: {
      type: Boolean,
      default: false
    }
  },

  data () {
    return {
      highlightedStars: 5,
      rating: 5,
      status: ''
    }
  },

  mounted () {
    this.highlightedStars = this.rating = this.startRating
  },

  methods: {
    resetRating () {
      this.highlightedStars = this.rating
    },

    selectRating (number) {
      if (this.readonly) return

      if (!this.preventVisuallyRatingChange) {
        this.rating = number
      }

      this.$emit('rating-changed', {rating: number})
    },

    highlightStars (number) {
      if (this.readonly) return

      this.highlightedStars = number
    }
  },

  computed: {
    starsCssClasses () {
      const rating = this.highlightedStars * 2

      const css = [`c-stars c-stars--p${rating} c-stars--selectable`]

      css.push(`c-stars--${this.size}`)

      if (this.inline) {
        css.push('c-stars--inline')
      }

      if (this.centered) {
        css.push('c-stars--center')
      }

      return css.join(' ')
    },

    icoCssClasses () {
      return `o-ico o-ico--star o-ico--${this.size}`
    },

    ratingStatus () {
      return ratingStatuses[this.highlightedStars - 1]
    }
  },

  watchers: {
    readonly: function (newValue) {
      if (newValue) {
        this.resetRating()
      }
    }
  }
}
</script>
<style lang="scss">
  .c-stars--selectable {
    cursor: pointer;
  }
</style>



// WEBPACK FOOTER //
// src/components/CStarsInput.vue